import {
  FETCH_SETTING_START,
  FETCH_SETTING_RECEIVED,
  FETCH_sETTING_ERROR,
  UPDATE_SETTING_ERROR,
  UPDATE_SETTING_START,
  UPDATE_SETTING_SUCCESS,
} from './../actions/settings';

const initialState = {
  fetching: false,
  error: false,
  refillFilter: 'onlyRefilledItems',
  shelfConfigId: null,
  updating: false,
};

const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SETTING_START:
      return {
        ...state,
        fetching: true,
        error: false,
      };
    case FETCH_SETTING_RECEIVED:
      return {
        ...state,
        fetching: false,
        refillFilter: action.data,
        shelfConfigId: action.shelfConfigId,
      };
    case FETCH_sETTING_ERROR:
      return {
        ...state,
        error: true,
      };
    case UPDATE_SETTING_START:
      return {
        ...state,
        error: false,
        updating: true,
      };
    case UPDATE_SETTING_SUCCESS:
      return {
        ...state,
        refillFilter: action.data,
        updating: false,
      };
    case UPDATE_SETTING_ERROR:
      return {
        ...state,
        error: true,
        updating: false,
      };
    default:
      return state;
  }
};

export default settingReducer;
